import React from 'react'
import { stringToHsl } from '../../../../Util'
import { TileEmptyImage, TileImageContainer } from './style'

interface IProps {
  imageUrl: string
  title: string
}

export const TileImage = ({ imageUrl, title }: IProps) => {
  if (!imageUrl) {
    return (
      <TileEmptyImage backgroundColor={stringToHsl(title, 50, 50)} />
    )
  }
  return <TileImageContainer source={{ uri: imageUrl }} />
}
